import React from 'react';
import AudienceLanding from './AudienceLanding';

export default function SchoolLanding() { return <AudienceLanding kind="school" />; }
